export default __webpack_public_path__ + "static/media/logo-only.e6ad42ef.png";